import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'app-spinner-loader',
    templateUrl: './spinner-loader.component.html',
    styleUrl: './spinner-loader.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerLoaderComponent {
    readonly showOverlay = input<boolean | null>(false);
}
